module.exports = __webpack_public_path__ + "static/media/img_new03@2x_en.77dbf7de.png";